// Chart.js - Tilt-frontend
import React, { PureComponent } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Customized, Brush } from 'recharts';
import moment from 'moment';
import { useState } from 'react';
//import Collapse from 'react-bootstrap/Collapse';



var data = [];

var i_factor = 0.001;
var u_factor = 0.001;

// Taustan lisäsy suoraan svg:llä
// - lisää Customized
// - tee const CustomBackground
// -Lisää se linechartille
const CustomBackground = () => (
  <svg>
    <defs>
      <linearGradient id="chartBackground" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#f3e5f5" />
        <stop offset="100%" stopColor="#f2f7f7" />
      </linearGradient>
    </defs>
    <rect x="0" y="0" width="100%" height="100%" fill="url(#chartBackground)" />
  </svg>
);

const PlotBackground = ({ width, height, margin }) => (
  <>
    <defs>
      <linearGradient id="plotGradient" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#ffffff" />
        <stop offset="95%" stopColor="#e8fafa" />
        <stop offset="100%" stopColor="#ffffff" />
      </linearGradient>
    </defs>
    <rect
      x={margin.left}
      y={margin.top}
      width={width - margin.left - margin.right}
      height={height - margin.top - margin.bottom}
      fill="url(#plotGradient)"
    />
  </>
);

// Tooltipin muotoilu
const CustomTooltip = ({ active, payload, label }) => {
  console.log('custom tooltip',label, ' => ', active, payload )
  if (active && payload && payload.length > 1) {
    console.log('tooltip', 'label:', label, 'payload:', payload, )
    let time = moment.unix(label).format('D.M.YYYY HH:mm:ss');
    return (
      <div className="custom-tooltip">
        <p className="label" style={{color: '#000000' }}>{`${time}`}</p>
        {/*
        <p className="label" style={{color: payload[0].color }}>{`${payload[0].name} ${payload[0].value.toFixed(1)}A`}</p>
        <p className="label" style={{color: payload[1].color }}>{`${payload[1].name} ${payload[1].value.toFixed(1)}V`}</p>
        */}
        <p className="label" style={{color: payload[0].color}}>{`X ${payload[0].value.toFixed(2)}°`}</p>
        <p className="label" style={{color: payload[1].color }}>{`Y ${payload[1].value.toFixed(2)}°`}</p>
        <p className="label" style={{color: payload[2].color }}>{`Z ${payload[2].value.toFixed(2)}°`}</p>
      </div>
    );
  }

  return null;
};

// Akselin väliotsikot
class CustomizedAxisTick extends PureComponent {
  render() {
    const { x, y, stroke, payload } = this.props;

    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={16} textAnchor="end" fill="#666" transform="rotate(-5)">
          {payload.value.toFixed(0) + " test"}
        </text>
      </g>
    );
  }
}

// <Chart key={name} configuration={configuration} measurements={measurements}>Heippa</Chart>
// Huom! measurementsissa tulee measurements, eikä all_measurements
//const Chart = ({name, configuration, history}) => {
//const Chart = ({name, device, history}) => {
const Chart = ({database}) => {
  //console.log('chart1', name, device, '=>', history)
  //let history = database;
    
  const [showXAxis, setShowXAxis] = useState(true);
  const [showYAxis, setShowYAxis] = useState(true);
  const [showZAxis, setShowZAxis] = useState(true);

    // Tyhjä chart
    if (database === '{}' || database === null || database.length === 0 || database === '[]')
      //return (<></>);

      return (
      <>
        <ResponsiveContainer width = '99%' height = {400}>
        

          <LineChart 
            width={600} 
            height={300} 
            data={[]} 
            onMouseMove={(e) => console.log('mousemove', e)}>

              <Customized component={PlotBackground} />                

              <CartesianGrid strokeDasharray="3 3" stroke="#ccc"  />


              <XAxis
                dataKey="timestamp"
                type="number" 
                domain = {['auto', 'auto']}
                name = 'timestamp'
                stroke = '#080000'
                tickFormatter = {(unixTime) => {
                  var muokattuAika = moment.unix(unixTime).format('DD-MM-YYYY')
                  return muokattuAika
                  }
                } 
                allowDuplicatedCategory={false}
                tickCount={15}
                //scale="time"
              />


              <YAxis yAxisId="angle" type="number" unit="°" domain = {[]} stroke="#080000" tickFormatter = {(x) => { return x.toFixed(1) }} label={{ value: "Angle", dx: -20, angle:-90, stroke:"#080000"}} />

              <Line type="monotone" yAxisId="angle" dataKey="x_angle_with_offset" stroke="#fc3f05" name="X" strokeWidth={1} dot={false} isAnimationActive={false} hide={!showXAxis} />
              <Line type="monotone" yAxisId="angle" dataKey="y_angle_with_offset" stroke="#8884d8" name="Y" strokeWidth={1} dot={false} isAnimationActive={false} hide={!showYAxis} />
              <Line type="monotone" yAxisId="angle" dataKey="z_angle_with_offset" stroke="#5fd400" name="Z" strokeWidth={1} dot={false} isAnimationActive={false} hide={!showZAxis} />

              {/* Zoomaus / aikajanan valinta */}
              <Brush dataKey="timestamp" height={20} stroke="#8884d8"
                tickFormatter = {(unixTime) => {
                  var muokattuAika = moment.unix(unixTime).format('DD-MM-YYYY')
                  return muokattuAika
                }
                } 
               />

              <Tooltip content={<CustomTooltip />} />
              <Legend formatter={(value) => value.charAt(0).toUpperCase() + value.slice(1)} verticalAlign="bottom" height={36} />


          </LineChart>
        </ResponsiveContainer>

        {/* Akselin piilotusnapit */}
        <div style={{ marginBottom: 10 }}>
          <button class="btn btn-primary m-2 w-15" onClick={() => setShowXAxis(prev => !prev)}>
            {showXAxis ? "Hide X" : "Show X"}
          </button>

          <button class="btn btn-primary m-2 w-15" onClick={() => setShowYAxis(prev => !prev)}>
            {showYAxis ? "Hide Y" : "Show Y"}
          </button>

          <button class="btn btn-primary m-2 w-15" onClick={() => setShowZAxis(prev => !prev)}>
            {showZAxis ? "Hide Z" : "Show Z"}
          </button>
        </div>


      </>
      );












    //console.log('chart2', name, device, '=>', history)

    //let currentConfig = config.find(x => x.site === name);
    //console.log('testifind', currentConfig)
    //console.log('history.length',history.length)
    let parsedHistoryJson = JSON.parse(database);
    if (parsedHistoryJson === undefined) return;
    //let deviceData = parsedHistoryJson[name];
    //if (deviceData === undefined) return;
    console.log('database:', parsedHistoryJson)


    //if (history.length < 10)
    //  console.log('ainoastaan 10 pitkä')
    //***let device = '100000005';
    //***let historyAsObject = parsedHistoryJson[device];//["C8:F0:9E:52:3B:70"];
    let historyAsObject = parsedHistoryJson;//["C8:F0:9E:52:3B:70"];
    if (historyAsObject === undefined || historyAsObject.length == 0)
      return;

    //if (historyAsObject === undefined) return;
    console.log('database array:', historyAsObject)


    let min = 0;
    let max = 0;
    
    //let ioutArray = historyAsObject.map(x => x['iout']);
    //let uoutArray = historyAsObject.map(x => x['uout']);


    //let ioutMin = Math.trunc( Math.min(...ioutArray) );
    //let ioutMax =  Math.trunc( Math.max(...ioutArray) );
    //let uoutMin =  Math.trunc( Math.min(...uoutArray) );
    //let uoutMax =  Math.trunc( Math.max(...uoutArray) );

    //ioutMin = (ioutMin - 1 < 0) ? 0 : ioutMin - 1;
    //ioutMax = ioutMax + 2;
    //uoutMin = (uoutMin - 1 < 0) ? 0 : uoutMin - 1;
    //uoutMax = uoutMax + 2;

    let ioutMin = 'auto';
    let ioutMax = 'auto';
    let x_angleArray = historyAsObject.map(x => x['x_angle']);

    console.log('database x_anglearray:', x_angleArray)
    var loppuaika = moment().subtract(2, 'month');
    //console.log('loppuaika', loppuaika)

    console.log('timestamp:',typeof(historyAsObject[0]['timestamp']))
    console.log('datalength:', historyAsObject.length)
    console.log('fist data point:', historyAsObject[0])


    return (
      <>
        <ResponsiveContainer width = '99%' height = {400}>
        

          <LineChart 
            width={600} 
            height={300} 
            data={historyAsObject} 
            onMouseMove={(e) => console.log('mousemove', e)}>

              <Customized component={PlotBackground} />                

              <CartesianGrid strokeDasharray="3 3" stroke="#ccc"  />


              <XAxis
                dataKey="timestamp"
                type="number" 
                domain = {['auto', 'auto']}
                name = 'timestamp'
                stroke = '#080000'
                tickFormatter = {(unixTime) => {
                  var muokattuAika = moment.unix(unixTime).format('DD-MM-YYYY')
                  return muokattuAika
                  }
                } 
                allowDuplicatedCategory={false}
                tickCount={15}
                //scale="time"
              />


              {/*<YAxis yAxisId="angle" type="number" unit="°" domain = {[ioutMin, ioutMax]} stroke="#080000" tickFormatter = {(x) => { return x.toFixed(1) }} label={{ value: "Angle", dx: -20, angle:-90, stroke:"#080000"}} />*/}
              <YAxis yAxisId="angle" type="number" unit="°" domain = {[0,50]} stroke="#080000" tickFormatter = {(x) => { return x.toFixed(1) }} label={{ value: "Angle", dx: -20, angle:-90, stroke:"#080000"}} />

              <Line type="monotone" yAxisId="angle" dataKey="x_angle_with_offset" stroke="#fc3f05" name="X*" strokeWidth={1} dot={false} isAnimationActive={false} hide={!showXAxis} />
              <Line type="monotone" yAxisId="angle" dataKey="y_angle_with_offset" stroke="#8884d8" name="Y" strokeWidth={1} dot={false} isAnimationActive={false} hide={!showYAxis} />
              <Line type="monotone" yAxisId="angle" dataKey="z_angle_with_offset" stroke="#5fd400" name="Z" strokeWidth={1} dot={false} isAnimationActive={false} hide={!showZAxis} />

              {/* Zoomaus / aikajanan valinta */}
              <Brush dataKey="timestamp" height={20} stroke="#8884d8"
                tickFormatter = {(unixTime) => {
                  var muokattuAika = moment.unix(unixTime).format('DD-MM-YYYY HH:mm')
                  return muokattuAika
                }
                } 
               />

              <Tooltip content={<CustomTooltip />} />
              <Legend formatter={(value) => value.charAt(0).toUpperCase() + value.slice(1)} verticalAlign="bottom" height={36} />

          </LineChart>
        </ResponsiveContainer>


        {/* Akselin piilotusnapit */}
        <div style={{ marginBottom: 10 }}>
          <button class="btn btn-primary m-2 w-15" onClick={() => setShowXAxis(prev => !prev)}>
            {showXAxis ? "Hide X" : "Show X"}
          </button>

          <button class="btn btn-primary m-2 w-15" onClick={() => setShowYAxis(prev => !prev)}>
            {showYAxis ? "Hide Y" : "Show Y"}
          </button>

          <button class="btn btn-primary m-2 w-15" onClick={() => setShowZAxis(prev => !prev)}>
            {showZAxis ? "Hide Z" : "Show Z"}
          </button>
        </div>

      </>
  )    

    /*
    return (
        <>
          <ResponsiveContainer width = '99%' height = {400}>
            <LineChart width={600} height={300} data={historyAsObject}>


                <CartesianGrid strokeDasharray="3 3" stroke="#ccc" fill='#f8f8f8' />

                <XAxis
                  dataKey="timestamp"
                  domain = {['dataMin', 'dataMax']}
                  name = 'timestamp'
                  stroke = '#f8f8f8'
                  tickFormatter = {(unixTime) => {
                    var muokattuAika = moment.unix(unixTime).format('DD-MM-YYYY')
                    return muokattuAika
                    }
                  } 
                  tickCount={15}
                  //scale="time"
                  type="number" 
                />
                
                <YAxis yAxisId="iout" dataKey="iout" type="number" unit="A" domain = {[ioutMin, ioutMax]} stroke="#f8f8f8" tickFormatter = {(x) => { return x.toFixed(1) }} label={{ value: "I", dx: -15, stroke:"#f8f8f8"}} />
                <YAxis yAxisId="uout" dataKey="uout" type="number" unit="V" domain = {[uoutMin, uoutMax]} stroke="#f8f8f8" tickFormatter = {(x) => { return x.toFixed(1)}} label={{ value: "U", dx: -15, stroke:"#f8f8f8"}} />

                <Line type="monotone" yAxisId="iout" dataKey="iout" stroke="#fc3f05" name="Virta" strokeWidth={1} dot={false} isAnimationActive={false} />
                <Line type="monotone" yAxisId="uout" dataKey="uout" stroke="#8884d8" name="Jännite" strokeWidth={1} dot={false} isAnimationActive={false} />

                <Tooltip content={<CustomTooltip />} />
                <Legend formatter={(value) => value.charAt(0).toUpperCase() + value.slice(1)} verticalAlign="bottom" height={36} />
            </LineChart>
          </ResponsiveContainer>
        </>
    )
   */
  };

  export default Chart
